import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#548dd4",
    },
    secondary: {
      main: "#6c757d",
    },
    success: {
      main: "#00acac",
    },
    info: {
      main: "#49b6d6",
    },
    warning: {
      main: "#f59c1a",
    },
    error: {
      main: "#ff5b57",
    },
    background: {
      default: "#dee2e6",
    },
  },
  typography: {
    fontFamily: "Helvetica",
    h1: {
      fontFamily: "Helvetica",
    },
    h2: {
      fontFamily: "Helvetica",
    },
    h3: {
      fontFamily: "Helvetica",
    },
    h4: {
      fontFamily: "Helvetica",
    },
    h5: {
      fontFamily: "Helvetica",
    },
    h6: {
      fontFamily: "Helvetica",
    },
  },
  props: {
    MuiAppBar: {
      color: "secondary",
    },
  },
  mixins: {
    MuiDataGrid: {
      // Pinned columns sections
      pinnedBackground: "#340606",
      // Headers, and top & bottom fixed rows
      containerBackground: "#548dd4",
    },
  },
  components: {
    MuiDataGrid: {
      containerBackground: "#548dd4",
      styleOverrides: {
        root: {
          border: "1px solid #ddd", // Add a border around the DataGrid
          fontFamily: "Helvetica", // Use the theme's font
          backgroundColor: "#ffffff", // Set the background color of the grid
        },
        columnHeaders: {
          backgroundColor: "#6c757d", // Primary color for column headers
          color: "#ffffff", // White text for headers
          fontWeight: "bold", // Bold text for headers
        },
        iconButtonContainer: {
          color: "#ffffff", // White color for icons (e.g., sorting icons)
        },
        "& .MuiDataGrid-columnHeaderCell .MuiIconButton-root": {
          color: "#ffffff !important", // White color for menu icon
        },

        filterIcon: {
          color: "#ffffff", // White color for filter icon
        },
        menuIcon: {
          color: "#ffffff", // White color for menu icon
        },
        sortIcon: {
          color: "#ffffff", // White color for sort icons
        },
        footerContainer: {
          backgroundColor: "#f5f5f5", // Light gray background for footer
        },
        row: {
          "&:nth-of-type(odd)": {
            backgroundColor: "#fafafa", // Alternate row background color
          },
        },
      },
    },
  },
});

export default theme;
